import { logger } from '../logger'
import { waitForCallback } from './waitForCallback'
import { waitForGlobal } from './waitForGlobal'

declare global {
  interface Window {
    _bmb?: {
      (command: string, callback: (data: any) => void): void
      _isPoweredByChiliPiper?: boolean
    }
  }
}

export const getBomboraGlobal = (signal?: AbortSignal) =>
  waitForGlobal(() => window._bmb, { signal })

export const deanonymizeWithBombora = async (signal?: AbortSignal) => {
  const awaitedBomboraClient = await getBomboraGlobal(signal)
  return new Promise<{ provider: 'Bombora'; data: unknown }>((resolve, reject) => {
    const register = waitForCallback(reject, signal)
    awaitedBomboraClient('vi', data => {
      logger.log('Bombora data CB:', data)
      const ended = register()
      if (!ended) {
        return resolve({
          provider: 'Bombora' as const,
          data,
        })
      }
    })
  })
}

export type TBomboraDeanonymizationEvent = Awaited<ReturnType<typeof deanonymizeWithBombora>>
